import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';

const styles = {
	default: (feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(250, 216, 129, 0.7)',
			}),
			text: new Text({
				text: ('' + feature.get('id')).replace('Stand ', ''),
			}),
		}),
	],
	special: (feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(73, 159, 228, 0.7)',
			}),
			text: new Text({
				text: ('' + feature.get('name')).replace('Stand ', ''),
			}),
		}),
	],
	'very-special': (feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(255, 248, 229, 0.7)',
			}),
			text: new Text({
				text: ('' + feature.get('name')).replace('Stand ', ''),
			}),
		}),
	],
};

const stylesDimmed = {
	default: (_feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(250, 216, 129, 0.5)',
			}),
		}),
	],
	special: (_feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(73,159,228,0.5)',
			}),
		}),
	],
	'very-special': (_feature) => [
		new Style({
			fill: new Fill({
				color: 'rgba(255, 248, 229, 0.5)',
			}),
		}),
	],
};

export default function (store) {
	let filter;
	let searchResultStaende;
	store.listen((data) => {
		filter = data.filter;
		searchResultStaende = data.searchResultStaende;
	});

	return function (feature) {
		const fill = feature.getProperties().fill;

		let type;
		switch (fill) {
			case 'rgb(255, 153, 204)':
			case 'rgb(241, 154, 190)':
				type = 'special';
				break;
			case 'rgb(255, 255, 255)':
				type = 'very-special';
				break;
			default:
				type = 'default';
		}

		const isFiltered = !filter || filter.indexOf(feature.getId()) > -1;
		const isSearchResult =
			!searchResultStaende ||
			!searchResultStaende.length ||
			searchResultStaende.indexOf(feature.getId()) > -1;
		return isFiltered && isSearchResult
			? styles[type](feature)
			: stylesDimmed[type](feature);
	};
}
